import { render } from "./Projects.vue?vue&type=template&id=317bfd69"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=317bfd69&lang=scss"
script.render = render

export default script